module.exports = __webpack_public_path__ + "static/media/mockup.eb2db95a.png";